import type React from 'react';
import { formatTwoDecimals } from '../../Utils/decimalUtils';
import type { InfoLabel } from '../Badges/InfoLabel';
import type { PlanStatus } from './priceSimulationModel';

export const EMPTY_METRIC = '-';

export const formatMetric = (value: number | null, format: (v: number) => string): string => (Number.isFinite(value) ? format(value as number) : EMPTY_METRIC);

export const orEmpty = (hasQuantity: boolean, text: string): string => (hasQuantity ? text : EMPTY_METRIC);

export const formatQuantity = (value: number): string => new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 2 }).format(value);

export const withSek = (value: number): string => `${formatTwoDecimals(value)} SEK`;

export const signed = (value: number): string => (value > 0 ? '+' : '');

export const formatSignedSek = (value: number): string => `${signed(value)}${withSek(value)}`;

export const formatMetricsPeriod = (start: string | null, end: string | null): { start: string; end: string } | null => {
    if (start === null || end === null) return null;
    const from = new Date(start);
    const to = new Date(end);
    if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return null;
    return { start: from.toLocaleDateString('sv-SE'), end: to.toLocaleDateString('sv-SE') };
};

type LabelType = React.ComponentProps<typeof InfoLabel>['type'];

const STATUS_LABEL_TYPES: Record<PlanStatus, LabelType> = { Draft: undefined, PendingReview: 'warning', Approved: 'success', Rejected: 'danger' };

export const getStatusLabelType = (status: PlanStatus): LabelType => STATUS_LABEL_TYPES[status];

export const deltaClass = (delta: number): string => {
    if (delta > 0) return 'text-success';
    return delta < 0 ? 'text-error' : 'text-primary';
};

export const formatTierRange = (points: { upperLimit?: number | null }[], i: number): string => {
    const upper = points[i].upperLimit ?? null;
    const lower = i === 0 ? 1 : (points[i - 1].upperLimit ?? 0) + 1;
    if (upper === null) return `${lower}+`;
    if (upper <= lower) return `${upper}`;
    return `${lower}–${upper}`;
};
